import { createApp } from "vue";
import popup from "./index.vue";

export const openImage = (
  imgUrl: string,
  showQr: boolean = false,
  qrSize: number = 220,
  qrLeft: number = 0,
  qrButtom: number = 0
) => {
  console.log(imgUrl);

  // 判断url是不是http前缀
  if (!imgUrl.startsWith("http") && !imgUrl.startsWith("https")) {
    imgUrl = new URL(imgUrl, import.meta.url).href;
  }
  console.log(imgUrl);

  const box = document.createElement("div");
  const Instance = createApp(popup as any, {
    imgUrl: imgUrl,
    showQr: showQr,
    qrSize: qrSize,
    qrLeft: qrLeft,
    qrButtom: qrButtom,
    onClosed: () => {
      Instance.unmount();
      box.remove();
    },
  });
  document.body.appendChild(box);
  Instance.mount(box);
};

export const openDefaultQr = () => {
  openImage("/image/qr/tjysls.png", true, 220, 78, 143);
};
